let SALE_API_URL = "";
if (window.location.hostname === "a-dev.tbbt.com.tw"){
  SALE_API_URL = `https://a-dev.tbbt.com.tw/reference-bg/sales`
} else if (window.location.hostname === "qa-textbook.hle.com.tw" || window.location.hostname === "qa-reference.hle.com.tw"){
  SALE_API_URL = `https://qa-rbook.hle.com.tw/reference-bg/sales`
}else if (window.location.hostname === "textbook.hle.com.tw" || window.location.hostname === "reference.hle.com.tw"){
  SALE_API_URL = `https://rbook.hle.com.tw/reference-bg/sales`
}else {
  SALE_API_URL = `https://qa-rbook.hle.com.tw/reference-bg/sales`
}

class SaleDataService {

   retrieveDisplaySales(edu, loc) {
    return  axios.get(`${SALE_API_URL}/display/${edu}/${loc}`);
  }

   retrieveSale(id){
    return  axios.get(`${SALE_API_URL}/${id}`);
  }
}
